import React, { useState } from "react";
import { Row, Col, Card, Form, Input, Spin, PageHeader, Alert, Select } from "antd";
import { useSelector } from "react-redux";
import { CustomBtn } from "../../components/Button";
import { useBillFeesMutation, useBillCardGetMutation, useBillCardReloadMutation } from "./service/bill-api";
import TransactionResume from "../../components/Dialog/transaction-resume";
import SuccessDialog from "../../components/Dialog/success";
import { loadFeaturesState } from "../../redux/featuresStorage";
const { Option } = Select;

export function BillCarteRoutePage() {
    const { currentAgent } = useSelector((state) => state.auth);
    const [billCardGet] = useBillCardGetMutation();
    const [billCardReload] = useBillCardReloadMutation();
    const [billFees] = useBillFeesMutation();
    const [show, setShow] = useState(false);
    const [cards, setCards] = useState([]);
    const [forfait, setForfait] = useState([]);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState();
    const [cardType, setCardType] = useState();
    const [fees, setFees] = useState();
    const [montant, setMontant] = useState();
    const [formdata, setFormData] = useState([]);
    const [form] = Form.useForm();
    const feature = loadFeaturesState();


    const handleSearch = async (value) => {
        setIsLoading(true);
        const data = {
            "msisdn": value.phone_number,
            "country": currentAgent.country,
            "pincode": "",
            "agent_msisdn": currentAgent.phone,
            "token": currentAgent.access_token
        }
        setFormData(value)
        billCardGet(data)
            .unwrap()
            .then((res) => {
                setIsLoading(false);
                setError();
                setCards(res)
            })
            .catch((error) => {
                setIsLoading(false);
                setError(error.data.error);
            });
    };

    const handleFees = async (value) => {
        setIsLoading(true);
        const data = {
            "agent_msisdn": currentAgent.phone,
            "agent_pin": "",
            "montant": value.montant,
            "operation": "W2B",
            "service": "GTP",
            "country": currentAgent.country
        };
        setMontant(value.montant);
        billFees(data)
            .unwrap()
            .then((res) => {
                setIsLoading(false);
                setError();
                setFees(res);
                setShow(true);
            })
            .catch((error) => {
                setIsLoading(false);
                setError(error.data.error);
            });
    };

    const handlePay = async (pin) => {
        setIsLoading(true);
        setShow(false);
        const data = {
            "agent_msisdn": currentAgent.phone,
            "pincode": pin,
            "amount": montant,
            "msisdn": formdata.phone_number,
            "card_type": cardType,
            "country": currentAgent.country,
            "token": currentAgent.access_token,
        };
        billCardReload(data)
            .unwrap()
            .then(() => {
                setIsSuccess(true);
                setIsLoading(false);
                setCards([])
                form.resetFields();
            })
            .catch((error) => {
                setIsLoading(false);
                setError(error.data.error);
            });
    };

    return (
        <div className="default-page">
            <TransactionResume
                title={`Recharge carte prepayée ${feature?.title} F CFA`}
                totalAmount={Math.floor(parseInt(montant) + (parseInt(fees?.fees) || 0))}
                message={
                    "Vous allez effectuer une recharge de carte prepayée d'un montant de " +
                    fees?.amount +
                    " F CFA"
                }
                fees={fees?.fees}
                status={show}
                handleCancel={() => setShow(false)}
                handlePay={handlePay}
            />
            <SuccessDialog
                message="Recharge effectuée avec succès"
                status={isSuccess}
                handleCancel={() => setIsSuccess(false)}
            />
            <PageHeader title={`Recharge carte prepayée`} />
            <Spin tip="Chargement..." spinning={isLoading}>
                <Row gutter={16}>
                    <Col lg={12} xs={24}>
                        <Card>
                            <Form name="basic" form={form} layout="vertical" onFinish={cards.length ? handleFees : handleSearch}>
                                <Form.Item
                                    label="Numero du client"
                                    name="phone_number"
                                    rules={[{ required: true, message: "entrer le numero client" }]}>
                                    <Input
                                        className="form-control"
                                        placeholder="Numero du client"
                                    />
                                </Form.Item>
                                {cards.length > 0 && (
                                    <div>
                                        <Form.Item label="Veuillez selectionner la liste des cartes:" name="cardType" rules={[{ required: true, message: "champs requis!" }]}>
                                            <Select placeholder="Liste des cartes" style={{ width: "100%" }} onChange={setCardType}>
                                                {cards.map(element => <Option value={element.card_type}>
                                                    <img src="./assets/img/mastercard.png" alt="card" width={35} />{" "}
                                                    <span>{element.registration_last_digits}</span>
                                                </Option>)}
                                            </Select>
                                        </Form.Item>

                                        <Form.Item
                                            label="Montant"
                                            name="montant"
                                            rules={[{ required: true, message: "entrer le montant" }]}>
                                            <Input
                                                className="form-control"
                                                placeholder="Montant"
                                            />
                                        </Form.Item>
                                    </div>
                                )}
                                {error && (
                                    <Form.Item>
                                        <Alert message={error} type="error" showIcon />
                                    </Form.Item>
                                )}
                                <Form.Item>
                                    <CustomBtn title={cards.length > 0 ? "Valider" : "Rechercher"} />
                                </Form.Item>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </Spin>
        </div>
    );
}
export default BillCarteRoutePage;
